const { test, staging, prod } = require("./servers.ts");

export const isReviewEnvironment = ({host, protocol}) => {
  if (protocol === "https:" && host.endsWith(".review.gapmaps.com")) {
    return true;
  }
};

export const dynamicEnvironment = () => {
  // To be used by all environments in order to allow any build (staging, prod)
  // from CI to just work
  const { protocol, host } = window.location;
  if(!isReviewEnvironment({protocol, host})) {
    return {};
  }
  const currentHost = host;
  const parentHost = currentHost.substring(currentHost.indexOf(".") + 1);
  const runtimeEnvironment = {
    demographicsUrl: `https://demographics-api.${parentHost}/api`,
    adminUrl: `https://admin-api.${parentHost}`,
    authUrl: `https://auth.${parentHost}`,
    imageBucket: `gapmaps-staging-images`,
    imageBaseUrl: `https://images.${parentHost}`,
    marketReportsUrl: `https://marketreports.${parentHost}`,
    metadataUrl: `https://retailers.${parentHost}/gapmaps/1.0/meta`,
    retailersUrl: `https://retailers.${parentHost}/gapmaps/1.0/retailer`,
    retailerUrl: `https://retailers.${parentHost}`,
    storageUrl: `https://storage-api.${parentHost}`,
    areasUrl: `https://retailers.${parentHost}/gapmaps/1.0/area`,
    webPushBrokerUrl: `https://broker-api.${parentHost}`,
    scraperUrl: `https://scraper-api.${parentHost}`,
    businessAdminAPIUrl: `https://business-admin-api.${parentHost}`,
    // suspect this is not correct
    // geocoderUrl: `https://geocoder.${parentHost}/pelias/api`,
    GapMaps2APP: `https://live.${parentHost}`,
    locationAPIUrl: `https://location2-api.${parentHost}/gapmaps`,
    layersUrl: `https://layers-api.${parentHost}`,
    analyticsApiUrl: `https://analytics-api.${parentHost}`,
    dbUrl: `https://data.${parentHost}`,
    poiAPIUrl: `https://poi-api.${parentHost}`,
    keycloak: {
      url: `https://keycloak.${parentHost}`,
      adminUrl: `https://keycloak-admin.${parentHost}`,
      realm: staging.keycloak.realm,
      clientId: staging.keycloak.clientId
    },
    geocoderUrl: staging.geocoderUrl,
    // explicitly disable logrocket *if* we're hosted on a review instance
    logRocket: ""
  };
  return runtimeEnvironment;
};
